'use strict';

var React = require('react');

var SvgToolsMajor = function SvgToolsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.414 1.586a2 2 0 0 1 0 2.828l-3 3-1.115 1.115-2.828-2.828 1.232-1.233.015-.015 2.868-2.867a2 2 0 0 1 2.828 0zm-8.47 11.299-2.788-2.787a4.67 4.67 0 0 1-5.919-5.901l2.523 2.522a1.5 1.5 0 0 0 2.121 0l.84-.84a1.5 1.5 0 0 0 0-2.12l-2.524-2.523a4.67 4.67 0 0 1 5.9 5.919l2.787 2.787 5.506 5.506a2.08 2.08 0 0 1-2.942 2.942l-5.506-5.506zm-1.415 1.414-3.287 3.287-4.242 1.414 1.414-4.243 3.287-3.286 2.828 2.828z"
  }));
};

exports.SvgToolsMajor = SvgToolsMajor;
